import { ReactNode } from 'react';

export type SearchSummaryActionsProps = {
    children: ReactNode;
};

export const SearchSummaryActions = ({ children }: SearchSummaryActionsProps) => (
    <div className="search-summary__actions">{children}</div>
);
